export const CaretLeftIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.8458 0.103016C11.9958 0.246016 12.0018 0.483016 11.8598 0.633016L4.8918 7.98002L11.8978 15.367C12.0398 15.517 12.0328 15.754 11.8828 15.897C11.7328 16.04 11.4948 16.033 11.3528 15.883L4.1408 8.27802C4.1348 8.27202 4.1378 8.26402 4.1328 8.25702C4.1278 8.25402 4.1208 8.25602 4.1168 8.25102C3.9668 8.10902 3.9598 7.87202 4.1028 7.72202L11.3158 0.117016C11.4578 -0.0329839 11.6958 -0.0399839 11.8458 0.103016Z"
      fill="currentColor"
    />
  </svg>
);
